import { Backdrop, Box, CircularProgress } from '@mui/material';
import { Footer, Header } from 'components';
import { routes } from 'configs';
import { useRoutes } from 'react-router-dom';
import { useAPIStates } from 'stores';

const AppContent = () => {
	const { fetching } = useAPIStates();

	return (
		<>
			<Backdrop
				sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }}
				open={fetching !== 0}
			>
				<CircularProgress size={80} color="info" />
			</Backdrop>
			<Header />
			<Box
				sx={{
					width: '100%',
					maxWidth: '600px !important',
					height: 'calc(100% - 56px)',
					display: 'flex',
					flexDirection: 'column',
					overflow: 'hidden',
				}}
			>
				{useRoutes(routes)}
			</Box>
			<Footer />
		</>
	);
};

export default AppContent;
